import { NetworkIntegrityProviderTypes } from "./networkIntegrityFilterConstants";
export enum NetworkIntegrityFilterAction {
  ProviderTypeFilterChanged = "PROVIDER_TYPE_FILTER_CHANGED"
};

export type NetworkIntegrityFilterActions =
  { type: NetworkIntegrityFilterAction.ProviderTypeFilterChanged, value: string };

export interface NetworkIntegrityFilterState {
  providerType: string;
};

export const networkIntegrityFilterInitialState: NetworkIntegrityFilterState = Object.freeze({
  providerType: NetworkIntegrityProviderTypes.Network,
});

export const networkIntegrityFilterReducer = (state: NetworkIntegrityFilterState, action: NetworkIntegrityFilterActions): NetworkIntegrityFilterState => {
  switch (action.type) {
    case NetworkIntegrityFilterAction.ProviderTypeFilterChanged:
      return Object.freeze({
        ...state,
        providerType: action.value,
      });
    default:
      return state;
  }
};